 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import {fetchQuery} from 'relay-runtime'

import Atmosphere from '../../Atmosphere'

const query = graphql`
  query getDemoEntitiesQuery($text: String!) {
    getDemoEntities(text: $text) {
      entities {
        lemma
        name
        salience
      }
    }
  }
`

const getDemoEntities = async (text) => {
  if (!text || text.length <= 2) return []
  const remoteAtmosphere = new Atmosphere()
  const res = await fetchQuery(remoteAtmosphere, query, {text}).toPromise()
  return _nullishCoalesce(_optionalChain([res, 'optionalAccess', _ => _.getDemoEntities, 'optionalAccess', _2 => _2.entities]), () => ( []))
}

export default getDemoEntities
